import React from 'react'
import Button from 'components/Form/Button'

export default function ExternalResourceLink({ course }) {
  if (!course?.external_url) return null

  const openExternalLink = () => {
    window.open(course.external_url, '_blank', 'noopener,noreferrer')
  }

  return (
    <Button type="button" color="primary" width="fit-content" onClick={openExternalLink}>
      {course?.external_label || 'Open link'}
    </Button>
  )
}
